import React from 'react';
import Layout, { LayoutProps } from '../Layout';
import { ChannelsPageLayoutHeaderContext } from './channelsLayoutHeaderContext';
import { ChannelsPageHeader } from './ChannelsPageHeader';

export const ChannelsPageLayout: React.FC<LayoutProps> = ({
  children,
  title,
  ...others
}) => {
  const [createButtonProps, setCreateButtonProps] = React.useState(null);
  const [channelNewButtonProps, setChannelNewButtonProps] = React.useState(
    null,
  );

  const [activeChannelTitle, setActiveChannelTitle] = React.useState<string>(
    '',
  );

  const [pageTitle, setPageTitle] = React.useState<string>(title || '');

  const [
    channelHeaderActions,
    setChannelHeaderActions,
  ] = React.useState<React.ReactNode | null>(null);

  const [
    channelHeaderMenuAnchorEl,
    setChannelHeaderMenuAnchorEl,
  ] = React.useState<null | HTMLElement>(null);

  /**
   * This state is used to hide the channels list toolbar when channels list has only one channel
   */
  const [
    channelsListToolbarHidden,
    setChannelsListToolbarHidden,
  ] = React.useState(true);

  /**
   * This state is used to hide the channels content toolbar
   */
  const [
    channelsContentToolbarHidden,
    setChannelsContentToolbarHidden,
  ] = React.useState(false);

  const channelsLayoutContextValue = React.useMemo(
    () => ({
      createButtonProps,
      setCreateButtonProps,
      activeChannelTitle,
      setActiveChannelTitle,
      channelHeaderActions,
      setChannelHeaderActions,
      channelHeaderMenuAnchorEl,
      setChannelHeaderMenuAnchorEl,
      channelsListToolbarHidden,
      setChannelsListToolbarHidden,
      pageTitle,
      setPageTitle,
      channelNewButtonProps,
      setChannelNewButtonProps,
      channelsContentToolbarHidden,
      setChannelsContentToolbarHidden,
    }),
    [
      createButtonProps,
      activeChannelTitle,
      channelHeaderActions,
      channelHeaderMenuAnchorEl,
      channelsListToolbarHidden,
      pageTitle,
      channelNewButtonProps,
    ],
  );
  return (
    <ChannelsPageLayoutHeaderContext.Provider
      value={channelsLayoutContextValue}
    >
      <Layout headerComponent={<ChannelsPageHeader />} {...others}>
        {children}
      </Layout>
    </ChannelsPageLayoutHeaderContext.Provider>
  );
};
